import React from 'react';

import { Icon } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './CommunityGroupCustomComponent.less';


/**
 * type: community-group
 * 组件: 社区团购-社区团购活动列表
 */

export default class CommunityGroupCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  isOpenCommunityGroup = () => {
    app._isOpenCommunityGroup();
  }

  init = (compindex, pageInstance) => {
    // 获取购买记录
    this.getGoodsIdxList(compindex);
    let _this = this;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let locationInfo = app.globalData.locationInfo;
    let param = {};
    if (customFeature.groupSetting && customFeature.groupSetting.height.indexOf('rem') < 0) {
      customFeature.groupSetting.height = parseInt(customFeature.groupSetting.height) / 100 * 2.34 + 'rem';
      customFeature.groupSetting['margin-top'] = parseInt(customFeature.groupSetting['margin-top']) / 100 * 2.34 + 'rem';
      customFeature.groupSetting['address-font-size'] = parseInt(customFeature.groupSetting['address-font-size']) / 100 * 2.34 + 'rem';
      customFeature.groupSetting['group-font-size'] = parseInt(customFeature.groupSetting['group-font-size']) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting.height = parseInt(customFeature.timeLineSetting.height) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting['margin-top'] = parseInt(customFeature.timeLineSetting['margin-top']) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting['underline-height'] = parseInt(customFeature.timeLineSetting['underline-height']) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting['font-size'] = parseInt(customFeature.timeLineSetting['font-size']) / 100 * 2.34 + 'rem';
      customFeature.searchSetting.height = parseInt(customFeature.searchSetting.height) / 100 * 2.34 + 'rem';
      customFeature.searchSetting['margin-top'] = parseInt(customFeature.searchSetting['margin-top']) / 100 * 2.34 + 'rem';
      let newData = {};
      newData['eles[' + compindex + '].customFeature'] = customFeature;
      pageInstance.setData(newData);
    }
    if (customFeature.showTimeline) {
      let timeLineContent = customFeature.timeLineSetting.content;
      for (let i = 0; i < timeLineContent.length; i++) {
        if (timeLineContent[i].show) {
          param.status = i;
          break;
        }
      }
    } else {
      if (customFeature.startActive && !customFeature.finishActive) {
        param.status = 5
      } else if (!customFeature.startActive && customFeature.finishActive) {
        param.status = 6
      } else if (customFeature.startActive && customFeature.finishActive) {
        param.status = 7
      } else if (!customFeature.startActive && !customFeature.finishActive) {
        param.status = 0
      }
    }
    // 切换团长后不需要重新请求团长列表
    if (pageInstance.data.eles[compindex].leaderInfo) {
      _this.getCommunityActiveList(compindex, param);
      return;
    }
    // 判断分享进来的团长可不可用
    if (app.globalData.communityUserToken) {
      this.checkGroupLeader(compindex, param, app.globalData.communityUserToken);
      return;
    }
    // 获取上一次团长 如果没有上一次团长则就近获取团长
    app.getStorage({
      key: 'groupToken',
      complete: function (res) {
        if (res && res.data) {
          _this.checkGroupLeader(compindex, param, res.data);
        } else if (locationInfo.latitude) {
          _this.latitude = locationInfo.latitude;
          _this.longitude = locationInfo.longitude;
          _this.getGroupList(compindex, param);
        } else {
          app.getLocation({
            type: 'gcj02',
            success: function (res) {
              let latitude = res.latitude;
              let longitude = res.longitude;
              pageInstance.requestNum++;
              app.sendRequest({
                hideLoading: true,
                url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
                data: {
                  latitude: latitude,
                  longitude: longitude
                },
                success: function (res) {
                  app.setLocationInfo({
                    latitude: latitude,
                    longitude: longitude,
                    address: res.data.formatted_addresses.recommend,
                    info: res.data
                  });
                }
              });
              _this.latitude = latitude;
              _this.longitude = longitude;
              _this.getGroupList(compindex, param);
            },
            fail: function (res) {
              let newdata = {};
              if (res.errMsg === 'getLocation:fail auth deny' || res.errMsg === "getLocation:fail:auth denied") {
                newdata['eles[' + compindex + '].location_address'] = '已拒绝定位';
              } else {
                newdata['eles[' + compindex + '].location_address'] = '定位失败';
              }
              pageInstance.setData(newdata);
            }
          });
        }
      }
    })
  }

  // 根据经纬度获取团长
  getGroupList = (compindex, param) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetDistributorExtList',
      method: 'post',
      data: {
        latitude: this.latitude,
        longitude: this.longitude,
        is_audit: 1,
        filter_deleted: 1
      },
      success: function (res) {
        if (res.data.length) {
          let data = {};
          data['eles[' + compindex + '].leaderInfo'] = res.data[0];
          app.setStorage({
            key: 'groupToken',
            data: res.data[0].user_token
          })
          pageInstance.setData(data);
        }
        _this.getCommunityActiveList(compindex, param);
      }
    })
  }

  getCommunityActiveList = (compindex, param) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let newdata = {};
    if (customFeature.vesselAutoheight == 1 || customFeature.vesselAutoheight == 2) {
      newdata['eles[' + compindex + '].customFeature.height'] = 'auto';
    } else {
      if (customFeature.height.indexOf('rpx') < 0) {
        newdata['eles[' + compindex + '].customFeature.height'] = parseInt(customFeature.height) * 2.34 + 'rpx';
      }
    }
    param.page_size = customFeature.loadingNum || 10;
    newdata['eles[' + compindex + '].param'] = param;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].communityGroup_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 1;
    pageInstance.setData(newdata);
    let leaderToken = pageInstance.data.eles[compindex].leaderInfo ? pageInstance.data.eles[compindex].leaderInfo.user_token : '';
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetGroupsByDistance',
      method: 'post',
      data: {
        idx_arr: {
          idx: 'title',
          idx_value: param.idx_value || ''
        },
        is_stock_gte_zero: customFeature.soldOut ? 1 : '',
        status: param.status >= 0 ? param.status + 1 : '',
        page_size: param.page_size,
        page: 1,
        leader_token: leaderToken
      },
      success: function (res) {
        let data = {};
        if (!res.data.length) {
          data['eles[' + compindex + '].loading'] = false;
          data['eles[' + compindex + '].communityGroup_data'] = [];
          data['eles[' + compindex + '].is_more'] = 0;
          pageInstance.setData(data);
          return;
        }
        data['eles[' + compindex + '].communityGroup_data'] = res.data;
        data['eles[' + compindex + '].is_more'] = res.is_more;
        data['eles[' + compindex + '].curpage'] = res.current_page;
        data['eles[' + compindex + '].loading'] = false;
        data['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(data);
      },
      fail: function () {
        let dataFail = {};
        dataFail['eles[' + compindex + '].loadingFail'] = true;
        dataFail['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(dataFail);
      }
    })
  }

  communityGroupScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    let curpage = compData.curpage + 1;
    let newdata = {};
    let param = {
      idx_arr: {
        idx: 'title',
        idx_value: (compData.param && compData.param.idx_value) || ''
      },
      status: compData.param.status >= 0 ? compData.param.status + 1 : '',
      page_size: compData.param.page_size,
      page: curpage,
      leader_token: pageInstance.data.eles[compindex].leaderInfo.user_token
    };
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    app.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetGroupsByDistance',
      data: param,
      method: 'post',
      hideLoading: true,
      success: function (res) {
        newdata = {};
        newdata['eles[' + compindex + '].communityGroup_data'] = [...compData.communityGroup_data, ...res.data];
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      fail: function () {
        newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    })
  }

  chengeCommunityGroup = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let token = pageInstance.data.eles[compindex].leaderInfo.user_token
    let router = app.returnSubPackageRouter("communityGroupSearchVillage");
    app.turnToPage(router + '?token=' + token + '&compindex=' + compindex);
  }

  toCommunityGroup = (e) => {
    let id = e.currentTarget.dataset.id;
    let leader_token = e.currentTarget.dataset.leaderToken || '';
    let isOnlineTime = e.currentTarget.dataset.status;
    let latitude = e.currentTarget.dataset.latitude;
    let longitude = e.currentTarget.dataset.longitude;
    let router = app.returnSubPackageRouter("communityGroupGoodDetail") + `?id=${id}&leader_token=${leader_token}&latitude=${latitude}&longitude=${longitude}`;
    if (!isOnlineTime) {
      app.turnToPage(router);
    } else {
      app.showModal({
        content: '活动已结束'
      })
    }
  }

  searchTimeLineActive = (event) => {
    let currentTarget = event.currentTarget.dataset;
    let compindex = currentTarget.compindex;
    let pageInstance = app.getAppCurrentPage();
    let param = {
      status: event.target.dataset.type
    };
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      app.showModal({
        content: '暂无团长，无法搜索'
      })
      return;
    }
    this.getCommunityActiveList(compindex, param);
  }

  searchGroupList = (event) => {
    let compindex = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let value = event.target.value;
    let param = pageInstance.data.eles[compindex].param;
    param.idx_value = value;
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      app.showModal({
        content: '暂无团长，无法搜索'
      })
      return;
    }
    this.getCommunityActiveList(compindex, param, pageInstance);
  }

  // 获取购买记录
  getGoodsIdxList = (compindex) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsIdxList',
      success: function (res) {
        pageInstance.setData({
          ['eles[' + compindex + '].buyerIndex']: 0,
          ['eles[' + compindex + '].buyerInfoList']: res.data || []
        });
        if (res.data.length) {
          _this.cycleGroupBuyerList(compindex);
        }
      }
    })
  }

  cycleGroupBuyerList = (compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let compindexParam = pageInstance.data.eles[compindex];
    if (compindexParam.buyerIndex < 0) {
      return;
    }
    setInterval(() => {
      let index = compindexParam.buyerIndex;
      let buyerInfoList = compindexParam.buyerInfoList
      index++;
      if (index == buyerInfoList.length - 1) {
        index = 0;
      }
      pageInstance.setData({
        ['eles[' + compindex + '].buyerIndex']: index
      });
    }, 8000)
  }

  // 判断团长可不可用
  checkGroupLeader = (compindex, param, userToken) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/CheckIsDistributorGroupLeaderInfo',
      data: {
        leader_token: userToken
      },
      success: function (res) {
        let newdata = {};
        if (!res.data.learder_info) {
          app.globalData.communityUserToken = '';
          app.removeStorage({
            key: 'groupToken',
            complete: function () {
              _this.init(compindex, pageInstance);
            }
          })
          return;
        }
        newdata['eles[' + compindex + '].leaderInfo'] = res.data.learder_info;
        pageInstance.setData(newdata);
        _this.getCommunityActiveList(compindex, param);
      },
    })
  }

  render() {
    const data = this.props.data;

    // 样式数据处理
    const styleObj = convertStyleData(data.style);

    // 时间轴1
    const $timeLineOne = () => {
      return <div className="time-line-box"
        onClick={this.searchTimeLineActive}
        data-compindex={this.props.index}
        style={{
          background: data.customFeature.timeLineSetting['background'],
          marginTop: data.customFeature.timeLineSetting['margin-top']
        }}>
        {data.customFeature.timeLineSetting.content.map((item, index) => {
          return <React.Fragment key={index}>
            {item.show &&
              <div data-type={index}
                style={{
                  fontWeight: data.param && data.param.status == index ? 600 : '',
                  color: data.param && data.param.status == index ? data.customFeature.timeLineSetting['underline-color'] : ''
                }}>{item.name}
                {data.param && data.param.status == index &&
                  <span className='under-line'
                    style={{
                      background: data.customFeature.timeLineSetting['underline-color'],
                      height: data.customFeature.timeLineSetting['underline-height']
                    }}>
                  </span>
                }
              </div>
            }
          </React.Fragment>
        })}
      </div>
    }

    // 时间轴2
    const $timeLineTwo = () => {
      return <div className="time-line-box"
        onClick={this.searchTimeLineActive}
        data-compindex={this.props.index}
        style={{
          background: data.customFeature.timeLineSetting['background'],
          marginTop: data.customFeature.timeLineSetting['margin-top']
        }}>
        {data.customFeature.timeLineSetting.content.map((item, index) => {
          return <React.Fragment key={index}>
            {item.show &&
              <div data-type={index} className={data.param && data.param.status == index ? 'selected' : ''}>
                <span data-type={index} style={{ background: data.param && data.param.status == index ? data.customFeature.timeLineSetting['slected-color'] : '' }}>{item.name}</span>
              </div>
            }
          </React.Fragment>
        })}
      </div>
    }

    //社区活动列表
    const $activityList = () => {
      return <ScrollView
       scroll-y="true"
       className={`scroll-ele ${data.type}`}
       style={{height: data.customFeature.height}}
       bindanimationend="animationEnd"
       data-compindex={this.props.index}
       data-type={data.type}
       bindscrolltolower={this.communityGroupScrollFunc}>
        {data.communityGroup_data && data.communityGroup_data[0] && data.communityGroup_data[0].group_info &&
          <React.Fragment>
            {data.communityGroup_data.map((item, index) => {
              return <div className="community-group-item"
                key={item.group_id}
                data-id={item.group_id}
                data-leader-token={item.user_token}
                data-longitude={item.leader_info.longitude}
                data-latitude={item.leader_info.latitude}
                data-status={item.group_info.status == 2}
                onClick={this.toCommunityGroup}>
                <div className="community-group-title">
                  <div className='group-active-name'>
                    {item.group_info.status == 1 && <label>进行中</label>}
                    {item.group_info.status == 2 && <label>已结束</label>}
                    {item.group_info.status == 3 && <label>即将开始</label>}
                    {item.group_info.status == 4 && <label>明日开始</label>}
                    {item.group_info.status == 5 && <label>更多预告</label>}
                    <span className="ellipsis">{item.group_info.title}</span>
                  </div >
                  <div className="column-time">
                    <span className="icon-comTime ico-moon" style={{ marginRight: '.09rem', color: item.group_info.status == 2 ? '#d2d2d2' : '#ff7100' }}></span>
                    <span>{item.group_info.start_date} - {item.group_info.end_date}</span>
                  </div>
                  <span className="group-title-illustration">{item.group_info.illustration}</span>
                </div>
                <div style={{ whiteSpace: 'nowrap' }}>
                  {data.communityGroup_data[index].goods_info && data.communityGroup_data[index].goods_info.map((item) => {
                    return <div className="img-content" key={item.id}>
                      <img src={item.cover} />
                      <div className="community-good-price">¥{item.price}</div>
                    </div>
                  })
                  }
                </div>
                <div className="community-group-describe">
                  <div className="describe-tag">浏览：{item.group_info.view_count}</div>
                  <div className="describe-tag">销量：{item.group_info.sold_count}</div>
                </div>
              </div>
            })}
          </React.Fragment>
        }
        {/* 加载loading */}
        {data.loading && <RequestStatus is="requestLoading" />}
        {/* 加载没有数据 */}
        {data.is_more == 0 && !(data.communityGroup_data && data.communityGroup_data[0] && data.communityGroup_data[0].group_info) && <RequestStatus is="requestNone" data={{ data: "暂无社区团购活动~" }} />}
        {/* 加载失败 */}
        {data.loadingFail && <RequestStatus is="requestFail" data={{ refreshEvent: 'communityGroupScrollFunc', compindex: data.compindex }} />}
        {/* 加载完所有数据 */}
        {data.is_more == 0 && !(data.communityGroup_data && data.communityGroup_data[0] && data.communityGroup_data[0].group_info) && data.customFeature.isShowFinishText && <RequestStatus is="requestAll" />}
        {/* 点击加载按钮 */}
        {data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && !!+data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
          <LoadingBtn customFeature={data.customFeature} data-compindex={this.props.index} onClick={this.communityGroupScrollFunc} />
        }
      </ScrollView>
    }

    return (
      <div className="custom-component community-group-wrap">
        <div className="element community-group" style={styleObj}>
          {data.customFeature.showSearch &&
            <div
              className="search-box"
              style={{ height: data.customFeature.searchSetting.height, marginTop: data.customFeature.searchSetting['margin-top'] }}>
              <div className="search-input">
                <Icon size='xxs' type='search' className="icon-search"></Icon>
                <input type='text'
                       placeholder='请输入搜索内容'
                      // TODO  bindconfirm={this.searchGroupList}
                      onBlur={this.searchGroupList}
                       data-compindex={this.props.index} />
              </div>
            </div>
          }
          {data.customFeature.showGroup &&
            <div className="community-head"
              style={{
                height: data.customFeature.groupSetting.height,
                marginTop: data.customFeature.groupSetting['margin-top'],
                background: data.customFeature.groupSetting.background
              }}>
              <img className="colone-avatar" src={data.leaderInfo && data.leaderInfo.logo || 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/new-zhichi-default.png'} />
              <div className='colone-detail-box'>
                <div className="colone-name"
                  style={{
                    color: data.customFeature.groupSetting['group-color'],
                    fontSize: data.customFeature.groupSetting['group-font-size']
                  }}>
                  {data.leaderInfo && data.leaderInfo.nick_name ? (data.leaderInfo.nick_name + '-') : '暂无团长'}{data.leaderInfo && data.leaderInfo.housing_estate}
                </div>
                <div className="colone-address"
                  style={{
                    color: data.customFeature.groupSetting['address-color'],
                    fontSize: data.customFeature.groupSetting['address-font-size']
                  }}>自提地址：{data.leaderInfo && data.leaderInfo.address_detail || "暂未设置"}
                </div>
              </div>
              {data.customFeature.groupSetting.changeCaptain &&
                <div
                  className="change-captain"
                  data-compindex={this.props.index}
                  onClick={data.leaderInfo ? this.chengeCommunityGroup : this.isOpenCommunityGroup}
                  style={{
                    color: data.customFeature.groupSetting['btn-color'],
                    background: data.customFeature.groupSetting['btn-background']
                  }}>
                  <span className='ico-moon icon-change'></span>{data.leaderInfo ? '切换团长' : '申请团长'}
                </div>
              }
              {data.buyerInfoList && !!data.buyerInfoList.length &&
                <div className='scroll-avatar-box'>
                  <div className='community-buyer-scrollling'>
                    {
                      data.buyerInfoList[data.buyerIndex] && (

                      <div className='scroll-avatar'>
                        <img src={data.buyerInfoList[data.buyerIndex].buyer_info.logo} />
                        <span className='scroll-name'>{data.buyerInfoList[data.buyerIndex].buyer_info.nickname}</span>下单成功了
                      </div>  
                      )
                    }
                  </div>
                </div>
              }
            </div>
          }
          {data.customFeature.timeLineSetting && data.customFeature.timeLineSetting.timeLineStyle == 1 && data.customFeature.showTimeline && $timeLineOne()}
          {data.customFeature.timeLineSetting && data.customFeature.timeLineSetting.timeLineStyle == 2 && data.customFeature.showTimeline && $timeLineTwo()}
          {$activityList()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/custom-component/community-group-custom-component/CommunityGroupCustomComponent.jsx